import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { merchantTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseCreateTsysStageOnlyVarProps = {
	onLoadingCallback?: Function;
	onSuccessCallback?: Function;
	onSettledCallback?: Function;
	name?: string;
};

type UseMutationCreateTsysStageOnlyVarProps = {
	merchantId: string;
	terminalId: string;
};

const useTsysStageOnlyVarMutation = () => {
	const dispatch = useDispatch();

	const useCreateTsysStageOnlyVar = ({
		onLoadingCallback,
		onSuccessCallback,
		onSettledCallback,
		name = "Stage only VAR",
	}: UseCreateTsysStageOnlyVarProps) =>
		useMutation(
			({
				merchantId,
				terminalId,
			}: UseMutationCreateTsysStageOnlyVarProps) =>
				merchantTerminalService.createTsysStageOnlyVar({
					merchantId,
					terminalId,
				}),
			{
				onMutate() {
					onLoadingCallback?.();
				},
				onSuccess() {
					onSuccessCallback?.();
					dispatch(
						uiActions.showSuccessNotification({
							title: `${name} has been created successfully`,
						}),
					);
				},
				onError(error: ErrorResponse) {
					var errorMessage =
						error?.title === "tsys_merchant_unknown_conflict"
							? `${name} failed as merchant not found in m-reports.  Please check m-reports before trying again.  If still fails, contact support.`
							: `${name} creation failed. Please try again, or contact support.`;
					dispatch(
						uiActions.showErrorNotification({
							title: errorMessage,
						}),
					);
				},
				onSettled() {
					onSettledCallback?.();
				},
			},
		);

	return { useCreateTsysStageOnlyVar };
};

export default useTsysStageOnlyVarMutation;
